import { BLOC_VOLTAGES, LoadMode } from '../enums';
import { BatteryRange } from './battery-range.model';

export interface SizingTool {
  sizingMode?: LoadMode;
  powerFactor?: number;
  upsEfficiency?: number;
  batteryRanges?: BatteryRange[];
  blocVoltage?: number | null;
  nbBlocks?: number;
  nbBlocksMax?: number;
  minCellVoltage?: number;
  designTemperature?: number;
  designCorrectionFactor?: number;
  agingCorrectionFactor?: number;
  loadValue?: number;
  backupMinutes?: number;
}

export interface SizingToolCreate {
  sizingMode?: LoadMode;
  powerFactor?: number;
  upsEfficiency?: number;
  batteryRanges?: string[];
  blocVoltage?: number | null;
  nbBlocks?: number;
  nbBlocksMax?: number;
  minCellVoltage?: number;
  designTemperature?: number;
  designCorrectionFactor?: number;
  agingCorrectionFactor?: number;
  loadValue?: number;
  backupMinutes?: number;
}

export function blocVoltageToNumber(
  voltage?: number | string | null,
): number | undefined {
  const parsedVoltage = Number(voltage);
  return Number.isFinite(parsedVoltage) &&
    BLOC_VOLTAGES.includes(parsedVoltage as number)
    ? parsedVoltage
    : undefined;
}

// Computes the equivalent number of 2V blocks from a count of blocks at a given bloc voltage.
export function computeTwoVoltBlocks(
  nbBlocks?: number,
  voltage?: number | null,
): number | undefined {
  const v = blocVoltageToNumber(voltage);
  if (!nbBlocks || !v) {
    return undefined;
  }
  return (nbBlocks * v) / 2;
}
